import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Tour from './Tour';

const Onboarding: React.FC = () => {
  const { user } = useAuth();
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    console.log('Onboarding component user object:', user);
    if (user && user.createdAt) {
      const createdAt = new Date(user.createdAt);
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

      if (createdAt > oneYearAgo) {
        setShowTour(true);
      }
    } else {
        console.log('Tour not shown because user or user.createdAt is missing.');
    }
  }, [user]);

  if (!showTour) {
    return null;
  }

  return <Tour />;
};

export default Onboarding;
